import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

// Neat, consistent back navigation for the ticketing flow. Goes back within the
// app when there's history to return to; otherwise falls back to a sensible route
// (so a deep-linked page never strands the user).
const BackBar = ({ label = "Back", fallback = "/events" }) => {
  const history = useHistory();
  const onBack = () => {
    if (history.length > 1) history.goBack();
    else history.push(fallback);
  };
  return (
    <Btn type="button" onClick={onBack} aria-label={label}>
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span>{label}</span>
    </Btn>
  );
};

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 8px 15px 8px 11px;
  color: #374151;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 16px;
  transition: all 0.15s ease;
  &:hover { border-color: #83b524; color: #5f8f12; box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06); }
  &:active { transform: translateY(1px); }
  @media (max-width: 640px) { margin-bottom: 12px; font-size: 13px; }
`;

export default BackBar;
